/** Entrar — MOBILE: una columna, campos grandes, teclado que no tapa el botón. */

import type { ReactNode } from 'react';

import { useEntrar } from '../features/useEntrar.ts';
import { MINIMO_CLAVE } from '../features/useClave.ts';
import { Aviso, Campo, Pila } from '../ui/componentes.tsx';

export function EntrarMobile({ onEntro }: { onEntro: () => void }): ReactNode {
  const f = useEntrar(onEntro);

  return (
    <div className="centrado">
      <form
        className="ancho-forma"
        onSubmit={(e) => {
          e.preventDefault();
          void f.enviar();
        }}
      >
        <div>
          {/* La pila entera llena, y no cuatro de seis.
              Acá no hay nada que medir —no hay sesión, ni plan, ni pérdida de grasa—, así que una
              pila a medias se leía como un progreso que no existe, justo antes del "Paso 1 de 4"
              del onboarding. Uniforme no cuenta nada: es la marca, y por eso va fuera del árbol
              de accesibilidad. */}
          <div aria-hidden="true">
            <Pila estados={['llena', 'llena', 'llena', 'llena', 'llena', 'llena']} alto={20} />
          </div>
          {/* La marca deja de ser el título: el título dice qué hace este formulario. Sin eso,
              entrar y crear cuenta se ven exactamente igual salvo por el texto del botón. */}
          <span className="eyebrow" style={{ display: 'block', marginTop: 12 }}>
            mg
          </span>
          <h1 className="titulo" style={{ marginTop: 2, fontSize: 26 }}>
            {f.titulo}
          </h1>
          <p className="nota">
            {f.modo === 'crear'
              ? 'Tus datos van a una planilla tuya, separada de la de cualquier otra persona.'
              : 'Registrá lo que levantás y mirá si lo que bajaste fue grasa.'}
          </p>
        </div>

        {f.modo === 'crear' && (
          <Campo
            etiqueta="Nombre"
            texto
            autoComplete="name"
            value={f.nombre}
            onChange={(e) => f.setNombre(e.target.value)}
          />
        )}

        <Campo
          etiqueta="Email"
          texto
          type="email"
          inputMode="email"
          autoComplete="email"
          autoCapitalize="none"
          value={f.email}
          onChange={(e) => f.setEmail(e.target.value)}
        />

        <Campo
          etiqueta="Clave"
          texto
          type="password"
          autoComplete={f.modo === 'crear' ? 'new-password' : 'current-password'}
          value={f.clave}
          onChange={(e) => f.setClave(e.target.value)}
          {...(f.modo === 'crear' ? { ayuda: `Mínimo ${MINIMO_CLAVE} caracteres.` } : {})}
        />

        {f.error && <Aviso tono="importante">{f.error}</Aviso>}

        {/* "Email o clave incorrectos" es lo mismo que ve alguien que nunca creó la cuenta. Acá,
            debajo del error y no al pie, está la única salida que le sirve. */}
        {f.sinCuenta && (
          <button type="button" className="boton" onClick={() => f.cambiarModo('crear')}>
            ¿Primera vez? Creá tu cuenta
          </button>
        )}

        <button type="submit" className="boton boton--principal" disabled={!f.valido || f.enviando}>
          {f.enviando ? 'Un momento…' : f.titulo}
        </button>

        {/* El botón arranca deshabilitado con el formulario vacío: sin esta línea es una pared. */}
        {f.queFalta && !f.enviando && (
          <p className="nota--fina" style={{ marginTop: -8 }}>
            {f.queFalta}
          </p>
        )}

        {!f.sinCuenta && (
          <button
            type="button"
            className="boton boton--fantasma boton--chico"
            onClick={() => f.cambiarModo(f.modo === 'crear' ? 'entrar' : 'crear')}
          >
            {f.modo === 'crear' ? 'Ya tengo cuenta' : 'Crear una cuenta'}
          </button>
        )}
      </form>
    </div>
  );
}
